import { type ReactNode, useEffect } from "react";
import { useThemeStore } from "./theme-store.ts";

interface Props {
  children: ReactNode;
}

export function ThemeProvider({ children }: Props) {
  return (
    <>
      <DarkThemeSync />
      <OccasionThemeSync />
      {children}
    </>
  );
}

/** Syncs dark/light to <html class="dark"> */
function DarkThemeSync() {
  const theme = useThemeStore((s) => s.theme);
  console.log("Theme:", theme);
  useEffect(() => {
    const root = document.documentElement;
    if (theme === "dark") {
      root.classList.add("dark");
    } else {
      root.classList.remove("dark");
    }
  }, [theme]);

  return null;
}

/** Syncs occasion theme to <html data-theme="..."> */
function OccasionThemeSync() {
  const occasionTheme = useThemeStore((s) => s.occasionTheme);
  console.log("Occasion theme:", occasionTheme);
  useEffect(() => {
    const root = document.documentElement;
    root.setAttribute("data-theme", occasionTheme);
  }, [occasionTheme]);

  return null;
}
